<template>
  <el-dialog :title="titleLabel" :visible.sync="dialogVisible" :close-on-click-modal="false">

    <el-form ref="form" :model="cow" label-width="120px">
      <el-form-item label="Numer krowy">
        <el-input v-model="cow.number" :disabled=!addMode></el-input>
      </el-form-item>
      <el-form-item label="Imię krowy">
        <el-input v-model="cow.name"></el-input>
      </el-form-item>
      <el-form-item label="Numer matki">
        <el-input v-model="cow.mothers_number"></el-input>
      </el-form-item>
      <el-form-item label="Numer ojca">
        <el-input v-model="cow.fathers_number"></el-input>
      </el-form-item>
      <el-form-item label="Data urodzenia">
        <el-date-picker type="date" placeholder="Wybierz datę" v-model="cow.birth_date" style="width: 100%;"></el-date-picker>
      </el-form-item>
      <el-form-item label="Sucha">
        <el-switch active-text="" inactive-text="" v-model="cow.dry"></el-switch>
      </el-form-item>
      <el-form-item label="Cielna">
        <el-switch active-text="" inactive-text="" v-model="cow.with_calf"></el-switch>
      </el-form-item>
      <el-form-item label="Grupa">
        <el-select v-model="cow.group" placeholder="Wybierz grupę">
          <el-option v-for="group in groups" :key="group.name" :label="group.name" :value="group.name"></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">Anuluj</el-button>
      <el-button type="danger" @click="deleteCow" v-if="!addMode">Usuń</el-button>
      <el-button type="primary" @click="saveCow(); dialogVisible = false" :disabled="!cow.number">{{confirmButtonLabel}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import bus from "@/bus";

export default {
  mounted: function() {
    bus.$on("showAddCowModal", this.showAddCowModal);
    bus.$on("showEditCowModal", this.showEditCowModal);
    bus.$on("showAddCalvedCowModal", this.showAddCalvedCowModal);

    bus.$on(
      "cow-selected",
      function(value) {
        this.selectedCow = value;
      }.bind(this)
    );
  },
  props: ["groups"],
  data: function() {
    return {
      dialogVisible: false,
      selectedCow: null,
      cow: {
        number: "",
        name: "",
        birth_date: new Date(),
        mothers_number: "",
        fathers_number: "",
        //      description:"",
        dry: false,
        with_calf: false,
        group: "",
        treatments: [],
        estrus: {
          is_during: ""
        }
      },
      titleLabel: "Dodaj krowę",
      confirmButtonLabel: "Dodaj",
      addMode: true,
      calving: false
    };
  },
  methods: {
    showAddCowModal() {
      this.titleLabel = "Dodaj krowę";
      this.confirmButtonLabel = "Dodaj";
      this.addMode = true;
      this.calving = false;

      this.cow = {
        number: "",
        name: "",
        birth_date: new Date(),
        mothers_number: "",
        fathers_number: "",
        //      description:"",
        dry: false,
        with_calf: false,
        group: "",
        treatments: [],
        estrus: {
          is_during: ""
        }
      };
      this.dialogVisible = true;
    },
    showEditCowModal() {
      this.titleLabel = "Edytuj krowę";
      this.confirmButtonLabel = "Zapisz";
      this.addMode = false;
      this.calving = false;

      if (this.selectedCow == null) {
        bus.$emit("errorMessage", "Najpierw zaznacz krowe");
        return;
      }
      this.cow = this.selectedCow;
      this.dialogVisible = true;
    },
    showAddCalvedCowModal() {
      this.titleLabel = "Dodaj wycieloną krowę";
      this.confirmButtonLabel = "Dodaj";
      this.addMode = true;
      this.calving = true;

      this.cow = {
        number: "",
        name: this.selectedCow.name,
        birth_date: new Date(),
        mothers_number: this.selectedCow.number,
        fathers_number: "",
        //      description:"",
        dry: false,
        with_calf: false,
        group: "",
        treatments: [],
        estrus: {
          is_during: ""
        }
      };
      this.dialogVisible = true;
    },
    saveCow() {
      if (this.addMode) {
        bus.$emit("save-new-cow", this.cow, this.calving);
      } else {
        bus.$emit("save-cow", this.cow);
      }
    },
    deleteCow() {
      this.$confirm("Czy napewno chcesz usunąć krowę?", "Uwaga!", {
        confirmButtonText: "OK",
        cancelButtonText: "Anuluj",
        type: "warning"
      })
        .then(() => {
          this.dialogVisible = false;

          bus.$emit("delete-cow", this.cow);
        })
        .catch(() => {
          this.dialogVisible = false;

          this.$message({
            type: "info",
            message: "Anulowano usuwanie"
          });
        });
    }
  }
};
</script>

<style>

</style>
